module.exports = __webpack_public_path__ + "static/media/OrddiktatUpper_Intro.a70f5d40.mp3";